import {
    AnimationBaseController,
    GameApiBase,
    GameRandom,
    GameStorageManager,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { AppStateEnum, GameModel } from '../../../../Models/Game/GameModel';
import { GameLogic } from '../../../../Logic/GameLogic';
import { AnimationContents } from '../../../../../AnimationContents';
import {
    ButtonToggleController,
    ISettingsScreenButtonControllerOptions,
} from './ButtonToggleController';
import { ButtonCloseController } from './ButtonCloseController';

export class SettingsController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic,
        @Inject private readonly _storageManager: GameStorageManager,
        @Inject private _arenaApi: GameApiBase
    ) {
        super('SettingsController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.SETTINGS_SCREEN_JSON,
            libraryName: 'main',
            childControllers: {
                button_sound: {
                    instanceName: `container.window.button_sound`,
                    view: ButtonToggleController,
                    model: this.$model,
                    options: <ISettingsScreenButtonControllerOptions>{
                        name: 'button_sound',
                        onClick: () => {
                            this._gameLogic.setSoundOnOff(
                                !this._gameLogic.isSoundOnOff()
                            );
                        },
                    },
                },
                button_music: {
                    instanceName: `container.window.button_music`,
                    view: ButtonToggleController,
                    model: this.$model,
                    options: <ISettingsScreenButtonControllerOptions>{
                        name: 'button_music',
                        onClick: () => {
                            this._gameLogic.setMusicOnOff(
                                !this._gameLogic.isMusicOnOff()
                            );
                        },
                    },
                },
                button_close: {
                    instanceName: `container.window.btn_close`,
                    view: ButtonCloseController,
                    model: this.$model,
                    options: <ISettingsScreenButtonControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlayByQuery(
                                'container',
                                'window close',
                                false,
                                false
                            );
                            this.$queue.get('hide').addToQueue();
                        },
                    },
                },
            },
            queue: {
                hide: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        if (this.$model.appState === AppStateEnum.game) {
                            this._gameLogic.showGamePause();
                        } else {
                            this._gameLogic.resetMenu();
                        }
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndPlayByQuery(
            'container',
            'window initialization',
            false,
            false
        );
    }

    protected onLandscape(): void {
        this.display.scale.set(1.3);
        this.display.y = 25;
    }
}
